module.exports = __webpack_public_path__ + "static/media/conect_4.615b2e89.jpg";